import { useStore } from "vuex"
import { computed, onMounted } from 'vue'
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "GlobalProfileLoginOverlay",
    setup(){
        const store = useStore()
        const loginUrl = computed(() => store.state.main.page_overlay_content_data.headerLoginUrl)
        let first, last, close
        const closeOverlay = () => {
            store.dispatch('main/closePageOverlay')
        }

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'GlobalProfileLoginOverlay',
                labelKey
            })
        
        
        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            first = document.querySelector('.kb-global-profile-login-overlay__kb-button--full-color-spot[data-order="first"]')
            last = document.querySelector('.kb-global-profile-login-overlay__cancel-button[data-order="last"]')
            close = document.querySelector('.kb-page-overlay__close')

            onTransitionendCallback({
                opening(){
                    close.focus()
                }
            }, { persistent: true })
        })
        
        return {
            tabTrap,
            loginUrl,
            getLabel,
            closeOverlay,
        }
    }
}